<template>
  <div>
    <v-card>
      <img class="text-md-center" alt="logo" src="/static/img/dfs-logo.png" srcset="/static/img/dfs-logo@2x.png 2x">
    </v-card>
  </div>
</template>

<script>
  export default {
    mounted () {
      if (this.$can('view', 'AppointmentSchedule')) {
        this.$router.push({ name: 'AppointmentsTable' })
      } else if (this.$can('view', 'AddLeadForm')) {
        this.$router.push({ name: 'AddLeadForm' })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Home.vue?c2288378